import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import { useAuth } from "../context/AuthContext";
import { COMPANY } from "../data/company";

export default function Footer() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <Logo size={30} light />
          <p className="footer__tagline">{t("brand.tagline")}</p>
        </div>

        <nav className="footer__col" aria-label={t("footer.product")}>
          <h2>{t("footer.product")}</h2>
          <Link to="/templates">{t("nav.templates")}</Link>
          <Link to="/create">{t("nav.create")}</Link>
          {user ? (
            <Link to="/dashboard">{t("nav.dashboard")}</Link>
          ) : (
            <Link to="/login">{t("nav.login")}</Link>
          )}
        </nav>

        <nav className="footer__col" aria-label={t("legal.title")}>
          <h2>{t("legal.title")}</h2>
          <Link to="/terms">{t("legal.terms")}</Link>
          <Link to="/privacy">{t("legal.privacy")}</Link>
          <Link to="/refunds">{t("legal.refunds")}</Link>
          <Link to="/cancellations">{t("legal.cancellations")}</Link>
        </nav>

        {(COMPANY.email || COMPANY.phone || COMPANY.address) && (
          <div className="footer__col">
            <h2>{t("footer.contact")}</h2>
            {COMPANY.email && (
              <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
            )}
            {COMPANY.phone && (
              <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}>
                {COMPANY.phone}
              </a>
            )}
            {COMPANY.address && <span>{COMPANY.address}</span>}
          </div>
        )}
      </div>

      <div className="container footer__legal">
        <p>
          © {year} {COMPANY.legalName || COMPANY.tradingName}
          {COMPANY.legalName &&
            ` (${t("footer.trading", { name: COMPANY.tradingName })})`}{" "}
          · {t("footer.reg", { number: COMPANY.registrationNumber })}
        </p>
        <p>{t("footer.payments")}</p>
      </div>
    </footer>
  );
}
